import React, { Component } from 'react';
import styles from './Index.less';
// import topContent from '../../assets/img/topContent.png';
import { Table, Row, Col, Button } from 'antd';
// import const from 'const.js'
// let $require = require;
const columns = [
	{
	  title: 'LP',
	  dataIndex: 'name',
	},
	{
	  title: 'Earned',
	  dataIndex: 'age',
	},
	{
	  title: 'APY',
	  dataIndex: 'address',
	},
	{
	  title: 'Action',
	  dataIndex: 'Action',
	  render: (text)=>{
		  return <div>
		  	 <Button type="primary"  shape="round">Stake</Button>&emsp;
		  	 <Button shape="round">Trade</Button>
		  </div>
		 
	  },
	  width: 170
	},
  ];
  const data = [
	{
	  key: '1',
	  name: 'John Brown',
	  age: 32,
	  address: '111',
	},
	{
	  key: '2',
	  name: 'Jim Green',
	  age: 42,
	  address: '111',
	},
	{
	  key: '3',
	  name: 'Joe Black',
	  age: 32,
	  address: '111',
	},
	{
		key: '4',
		name: 'Joe Black',
		age: 32,
		address: '111',
	  },
  ];
  
// @connect(({ layoutsData, classreport }) => ({
// 	layoutsData, classreport
// }))
class Index extends Component {
	constructor(props) {
		super(props);
		this.state = {
			classReviewData:{},
			isIOS: false,
			status:"none",
			courseImg:"",
			lessonId:null,
			visible:false,
			isGoHomework:null,
			aaa: 3
		}
	}
	// 页面第一次加载完
	componentDidMount() {
		console.log(this.props.layoutsData, 'layoutsData')
	}
  	
	render() {
		return (
			<div className={styles.home}>
				
				<div className={styles.topHome}>
					<div className={styles.topSpan}>
						{/* <img src={topContent}/>Tokens in BSC ecology , MDEX.COM is definitely the greater , faster , better and cheaper choice ! */}
					</div>
					
					<div className={styles.secondSpan}>
						MDEX is committed to building a DeFi platform that integrates DEX , IMO , and DAO .
					</div>
					<div className={styles.secondSpan}>
						{/* --- */}
						<span className={styles.round}></span>
						<span className={styles.lineRound}></span>
						<span className={styles.round}></span>
					</div>
				</div>
				
				<div className={styles.contentHome}>
					
					<div className={styles.topTitle}>
						<span className={styles.topText}>Total Value Locked </span>
						<span className={styles.topNum}>2,835,304,027.35 </span>
						<span className={styles.topText}>USDT</span>
					</div>
					<div className={styles.sencondArea}>
						<Row gutter={24} type="flex" justify="center">
							<Col xl={10} md={10} xs={10}>
							
								<div className={styles.sencondItem}>
									<div></div>
									<span className={styles.secondText}>Current TVL</span>&emsp;
									<span className={styles.secondNum}>2,835,304,027.35 </span>&emsp;
									<span className={styles.secondText}>USDT</span>
								</div>
								
								
							</Col>
							<Col  xl={10} md={10} xs={10}>
								
								<div className={styles.sencondItem}>
									<div></div>
									<span className={styles.secondText}>Current TVL</span>&emsp;
									<span className={styles.secondNum}>2,835,304,027.35 </span>&emsp;
									<span className={styles.secondText}>USDT</span>
								</div>
							</Col>
						</Row>
						<div className={styles.sencondTitle}></div>
					</div>	
					<div className={styles.thirdArea}>
						<Row type="flex" justify='center'>
							<Col  xl={8} md={10} xs={10}>
							
								<div className={styles.thirdItem}>
									<div className={styles.secondText}>Current Price</div>
									<div className={styles.thirdPrice}>$2,835,304,027.35 </div>
								</div>
								<div className={styles.thirdItem}>
									<div className={styles.secondText}>To be Repurchased (HECO&BSC)</div>
									<div className={styles.thirdPrice}>$2,835,304,027.35 </div>
								</div>
							</Col>
							<Col  xl={8} md={10} xs={10}>
								
								<div className={styles.thirdItem}>
									<div className={styles.secondText}>MDX Balance</div>
									<div className={styles.thirdPrice}>$2,835,304,027.35 </div>
								</div>
								<div className={styles.thirdItem}>
									<div className={styles.secondText}>To be Repurchased (HECO&BSC)</div>
									<div className={styles.thirdPrice}>$2,835,304,027.35 </div>
								</div>
							</Col>
							<Col  xl={8} md={24} xs={24}>
								
								<div className={styles.thirdItem}>
									<div className={styles.secondText}>Pending Rewards (HECO&BSC)</div>
									<div className={styles.thirdPrice}>$2,835,304,027.35 </div>
								</div>
								<div className={styles.thirdItem}>
									<div className={styles.secondText}>Halving Countdown</div>
									<div className={styles.thirdPrice}>Around $2,835,304,027.35 </div>
								</div>
							</Col>
						</Row>
					</div>
					<div  className={styles.forthArea}>
						<Row gutter={24} type="flex" justify='center'>
							<Col  xl={12} md={24} xs={24}>
							
								<div className={styles.forthItem}>
									
									<div className={styles.forthTop}>

										<div className={styles.round}></div>
										<div className={styles.showText}>
											<span className={styles.leftText}>Boardroom</span>
											<span className={styles.rightText}>more ></span>
										</div>
										
									</div>
									<Table columns={columns} dataSource={data} size="middle" />
								</div>
								
							</Col>
							<Col  xl={12} md={24} xs={24}>
								
								<div className={styles.forthItem}>
									<div className={styles.forthTop}>

										<div className={styles.round}></div>
										<div className={styles.showText}>
											<span className={styles.leftText}>Boardroom</span>
											<span className={styles.rightText}>more ></span>
										</div>

									</div>
									<Table columns={columns} dataSource={data} size="middle" />
								</div>
								
							</Col>
							
						</Row>
					</div>
					<div className={styles.fiveArea}>
						<Row gutter={24} type="flex" justify='center'>
							<Col  xl={12} md={12} xs={24}>
							
								<div className={styles.fiveItem}>
									<div className={styles.fiveTextItem}>
										<div className={styles.secondText}>Halving Countdown</div>
										<div className={styles.fivePrice}>Around $2,835,304,027.35 </div>
									</div>
									
								</div>
								
							</Col>
							<Col  xl={12} md={12} xs={24}>
								
								<div className={styles.fiveItem}>
									
									<div className={styles.fiveTextItem}>
										<div className={styles.secondText}>Halving Countdown</div>
										<div className={styles.fivePrice}>Around $2,835,304,027.35 </div>
									</div>
								</div>
								
							</Col>
							
						</Row>
					</div>
					<div className={styles.sixArea}>
						<Row type="flex" justify='center'>
							
							<Col  xl={11} md={12} xs={24}>
								
								<div className={styles.sixItem}>
									<span className={styles.leftText}>MDX Balance</span>
									<span className={styles.sixPrice}>$2,8 </span>
								</div>
								<div className={styles.sixItem}>
									<span className={styles.leftText}>To be Repurchased (HECO&BSC)</span>
									<span className={styles.sixPrice}>$2, </span>
								</div>
								{/* <Divider type="vertical" /> */}
							</Col>
							<Col  xl={11} md={12} xs={24}>
								
								<div className={styles.sixItem}>
									<span className={styles.leftText}>Pending Rewards (HECO&BSC)</span>
									<span className={styles.sixPrice}>$2, </span>
								</div>
								<div className={styles.sixItem}>
									<span className={styles.leftText}>Halving Countdown</span>
									<span className={styles.sixPrice}>Around $2,454 </span>
								</div>
							</Col>
						</Row>
					</div>
				</div>
				<div className={styles.aplication}>
					<div className={styles.title}>Application Scenarios</div>
					<div className={styles.content}>
						{/* <Row type="flex" justify='center'>
							
							<Col  xl={8} md={8} xs={24}>
								
								<div></div>
							</Col>
							<Col  xl={8} md={8} xs={24}>
								
								<div></div>
							</Col>
							<Col  xl={8} md={8} xs={24}>
								
								<div></div>
							</Col>
						</Row> */}
						<div></div>
						<div></div>
						<div></div>
						
						
					</div>
				</div>
				<div className={styles.aplicationSecond}>
					<div className={styles.title}>Application Scenarios</div>
					<div className={styles.content}>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
				<div className={styles.aplicationThird}>
					<div className={styles.title}>Partner</div>
					<div className={styles.container}>
						<div className={styles.content}>
							<div></div>
							<div></div>
							<div></div>
						</div>
						<div className={styles.content}>
							<div></div>
							<div></div>
							<div></div>
						</div>
						<div className={styles.content}>
							<div></div>
							<div></div>
							<div></div>
						</div>
					</div>
					
				</div>
				<div className={styles.bottomArea}>
					<div>
						MDEX Bug Bounty Campaign
					</div>
					<div>
						<Button>Details</Button>
					</div>
				</div>
      		</div>
		)
	}
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/Home/Index.js